import apiAxios from '../../services/apiAxios';
import { getAccesos } from '../../helpers/user_auth';
import helpers from '../../mixins/helpers';
import signalrClient from "@/plugins/signalrClient";

const state = {
  userId: 0,
  username: '',
  avatar: '',
  avatarExtension: '',
  nombre: '',
  nombreCompleto: '',
  tokenString: '',
  rol: '',
  rolId: 0,
  // empresaId: 0,
  
  /* Datos de la empresa */
  empresa: {},
  // empresaPaisId: 0,
  
  nav: [],

  authValid: false,
  passwordVencido: false,
  // passwordTemporal: false
};

const mutations = {
  'LOGIN'(state, params) {
    state.userId = params.user.id;
    state.username = params.user.username;
    state.nombre = params.user.nombre;
    state.nombreCompleto = params.user.nombreCompleto;
    // state.avatar = params.user.avatar;
    state.avatar = params.user.base64Avatar;
    state.avatarExtension = params.user.avatarExtension;
    state.rol = params.user.usuarioRol;
    state.rolId = params.user.usuarioRolId;

    /* Datos de la empresa */
    state.empresa = {};

    if (params.empresa) {
      state.empresa = params.empresa;
    }
  
    state.tokenString = params.tokenString;
    // signalrClient.init(state.tokenString);

    /* Recuperamos las opciones del menú */
    getMenu(state);
  },
  'LOGOUT'(state) {
    state.userId = 0;
    state.username = '';
    state.nombre = '';
    state.nombreCompleto = '';
    state.avatar = '';
    state.avatarExtension = '';
    state.rol = '';
    state.rolId = 0;

    /* Datos de la empresa */
    state.empresa = {};

    state.tokenString = '';
    // signalrClient.stop();
    
    state.nav = [];
  },
  'PERFIL'(state, params) {
    state.nombre = params.nombre;
    state.avatar = params.avatar;
    state.avatarExtension = params.avatarExtension;
  },
  'INICIALIZAR_AUTH'(state) {
    state.authValid = false;
    state.passwordVencido = false;
    },
  'SET_AUTH'(state, auth) {
    state.authValid = true;
    state.passwordVencido = auth.passwordVencido;
  },
};

const actions = {
  tryLogin: ({commit}) => {
    return new Promise((resolve, reject) => {
      /* Recuperamos los datos del localStorage */  
      var userName = localStorage.getItem('userName');
      var tokenString = localStorage.getItem('token');
      var expirationDate = new Date(localStorage.getItem('expirationDate', expirationDate));
      var currentDate = new Date();

      /* Validamos datos del usuario y la fecha de expiración */
      if (userName && tokenString
          && expirationDate.getTime() > currentDate.getTime()) {
        
        var credenciales = {
          username: userName,
          tokenString: tokenString
        }
        apiAxios.post('auth/autologin', credenciales) 
          .then(res => {
            commit('LOGIN', res.data);

            const now = new Date();
            const expirationDate = new Date(now.getTime() + 28800000);
            localStorage.setItem('userName', res.data.user.username);
            localStorage.setItem('token', res.data.tokenString);
            localStorage.setItem('expirationDate', expirationDate);

            signalrClient.init(res.data.tokenString);

            resolve();
          })
          .catch(error => reject(helpers.methods.getErrorMessage(error)));
        } else {
          reject();
        }
    })
  },
  authValid: ( { commit  }, params) => {
    return new Promise((resolve, reject) => {
      commit('INICIALIZAR_AUTH');

      apiAxios.post('auth/auth', params) 
        .then(res => {
          commit('SET_AUTH', res.data);

          resolve();
        })
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
  login: ( { commit  }, params) => {
    return new Promise((resolve, reject) => {
      commit('LOGOUT');

      apiAxios.post('auth/login', params) 
        .then(res => {
          commit('LOGIN', res.data);
          /*console.log(res.data);*/

          const now = new Date();
          const expirationDate = new Date(now.getTime() + 28800000);
          localStorage.setItem('userName', res.data.user.username);
          localStorage.setItem('token', res.data.tokenString);
          localStorage.setItem('expirationDate', expirationDate);

          signalrClient.init(res.data.tokenString);

          resolve();
        })
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
  logout: ( { commit, dispatch } ) => {
    commit('LOGOUT');

    localStorage.removeItem('userName');
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');

    signalrClient.stop();
    
    /* Inicializamos las opciones de cada modulo */
    dispatch('articulos/inicializarOpciones', null, { root: true });
    dispatch('bienes/inicializarOpciones', null, { root: true });
    dispatch('articulosTipos/inicializarOpciones', null, { root: true });
    dispatch('bancos/inicializarOpciones', null, { root: true });
    dispatch('bancoschequeras/inicializarOpciones', null, { root: true });
    dispatch('bancoscuentas/inicializarOpciones', null, { root: true });
    dispatch('bancosmovimientos/inicializarOpciones', null, { root: true });
    dispatch('bancosmovimientostipos/inicializarOpciones', null, { root: true });
    dispatch('cajas/inicializarOpciones', null, { root: true });
    dispatch('cajasmovimientos/inicializarOpciones', null, { root: true });
    dispatch('cajasregistros/inicializarOpciones', null, { root: true });
    dispatch('cajastransferencias/inicializarOpciones', null, { root: true });
    dispatch('cancelacionesmotivos/inicializarOpciones', null, { root: true });
    dispatch('cargos/inicializarOpciones', null, { root: true });
    dispatch('certificadosServicio/inicializarOpciones', null, { root: true });
    dispatch('chequespropios/inicializarOpciones', null, { root: true });
    dispatch('chequesterceros/inicializarOpciones', null, { root: true });
    dispatch('clientes/inicializarOpciones', null, { root: true });
    dispatch('cobros/inicializarOpciones', null, { root: true });
    dispatch('compras/inicializarOpciones', null, { root: true });
    dispatch('comprasImpuestos/inicializarOpciones', null, { root: true });
    dispatch('cuentacorrienteclientes/inicializarOpciones', null, { root: true });
    dispatch('cuentacorrienteproveedores/inicializarOpciones', null, { root: true });
    dispatch('etiquetasProveedores/inicializarOpciones', null, { root: true });
    dispatch('evaluacionesProveedores/inicializarOpciones', null, { root: true });
    dispatch('evaluacionesUsuarios/inicializarOpciones', null, { root: true });
    dispatch('facturasProforma/inicializarOpciones', null, { root: true });
    dispatch('formaspago/inicializarOpciones', null, { root: true });
    dispatch('girosEmpresas/inicializarOpciones', null, { root: true });
    dispatch('impuestosOrganismos/inicializarOpciones', null, { root: true });
    dispatch('ingresosegresos/inicializarOpciones', null, { root: true });
    dispatch('interesesBancariosRubros/inicializarOpciones', null, { root: true });
    dispatch('liquidacionesSueldos/inicializarOpciones', null, { root: true });
    dispatch('localidades/inicializarOpciones', null, { root: true });
    dispatch('ordenesproveedores/inicializarOpciones', null, { root: true });
    dispatch('ordenesSubtrabajos/inicializarOpciones', null, { root: true });
    dispatch('pagos/inicializarOpciones', null, { root: true });
    dispatch('paises/inicializarOpciones', null, { root: true });
    dispatch('personalNovedades/inicializarOpciones', null, { root: true });
    dispatch('personel/inicializarOpciones', null, { root: true });
    dispatch('planesPagos/inicializarOpciones', null, { root: true });
    dispatch('presupuestosinternos/inicializarOpciones', null, { root: true });
    dispatch('presupuestosinternoscancelados/inicializarOpciones', null, { root: true });
    dispatch('proveedores/inicializarOpciones', null, { root: true });
    dispatch('provincias/inicializarOpciones', null, { root: true });
    dispatch('remitos/inicializarOpciones', null, { root: true });
    dispatch('remitosdestinos/inicializarOpciones', null, { root: true });
    dispatch('remitosFacturacion/inicializarOpciones', null, { root: true });
    dispatch('retencionesclientes/inicializarOpciones', null, { root: true });
    dispatch('retencionesregimenes/inicializarOpciones', null, { root: true });
    dispatch('retencionestipos/inicializarOpciones', null, { root: true });
    dispatch('rubrostrabajos/inicializarOpciones', null, { root: true });
    dispatch('tarjetas/inicializarOpciones', null, { root: true });
    dispatch('tarjetasmarcas/inicializarOpciones', null, { root: true });
    dispatch('tiposNovedades/inicializarOpciones', null, { root: true });
    dispatch('transferenciasPremios/inicializarOpciones', null, { root: true });
    dispatch('transferenciasPremiosImputaciones/inicializarOpciones', null, { root: true });
    dispatch('usuarios/inicializarOpciones', null, { root: true });
    dispatch('vendedores/inicializarOpciones', null, { root: true });
    dispatch('ventas/inicializarOpciones', null, { root: true });
    dispatch('viaticos/inicializarOpciones', null, { root: true });
    dispatch('viaticosRubros/inicializarOpciones', null, { root: true });
  },
  forgotPassword ( {}, params ) {
    return new Promise((resolve, reject) => { 
      apiAxios.post('auth/forgot', params)
        .then(() => resolve())
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
  resetPassword ( {}, params ) {
    return new Promise((resolve, reject) => { 
      apiAxios.post('auth/reset-password', params)
        .then(() => resolve())
        .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },
  updatePassword ( {}, params ) {
    return new Promise((resolve, reject) => {
        let url = 'auth/pass';
        apiAxios.post(url, params)
            .then(response => resolve(response))
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
    })
  },    
};

const getters = {
  loggedIn(state) {
    if (state.username) {
      if (state.username != '') {
        if (!(/true/i).test(state.passwordVencido)) {
          return true;
        }
      }
    }
    return false;
  },
  userId (state) {
    return state.userId;
  },
  username (state) {
    return state.username;
  },
  nombre (state) {
    return state.nombre;
  },
  nombreCompleto (state) {
    return state.nombreCompleto;
  },
  avatar (state) {
    return state.avatar;
  },
  avatarExtension (state) {
    return state.avatarExtension;
  },
  tokenString (state) {
    return state.tokenString;
  },
  rolId (state) {
    return state.rolId;
  },
  rol (state) {
    return state.rol;
  },

  empresaId (state) {
    if (state.empresa) {
      if (state.empresa.id) {
        return state.empresa.id;
      }
    }
    return 0;
  },
  empresa (state) {
    if (state.empresa) {
      if (state.empresa.nombreComercial) {
        return state.empresa.nombreComercial.trim();
      }
    }
    return '';
  },
  paisId (state) {
    if (state.empresa) {
      if (state.empresa.paisId) {
        return state.empresa.paisId;
      }
    }
    return 0;
  },

  nav (state) {
    return state.nav;
  },
  passwordVencido(state) {
    return (/true/i).test(state.passwordVencido);
  },
  tieneAcceso: (state) => (route) => {
    let accesos = getAccesos();
    let routePath = route.path;

    // if (route.params) {
    //   // console.log(route.params);
    //   if (route.params.hasOwnProperty('impuestoOrganismoId')) {
    //     routePath = routePath.replace('/' + route.params.impuestoOrganismoId, '/:impuestoOrganismoId');
    //   }
    //   if (route.params.hasOwnProperty('clienteId')) {
    //     routePath = routePath.replace('/' + route.params.clienteId, '/:clienteId');
    //   }
    //   if (route.params.hasOwnProperty('tarjetaId')) {
    //     routePath = routePath.replace('/' + route.params.tarjetaId, '/:tarjetaId');
    //   }
    //   if (route.params.hasOwnProperty('tarjetaResumenId')) {
    //     routePath = routePath.replace('/' + route.params.tarjetaResumenId, '/:tarjetaResumenId');
    //   }
    //   if (route.params.hasOwnProperty('id')) {
    //     routePath = routePath.replace('/' + route.params.id, '/:id');
    //   }
    // }

    switch (state.rolId) {
      case 1:
      case 2:
      case 6:  
      case 8:
        return true;    
    
      default:
        let lastMatched;
        let lastMatchedPath;
        if (route.matched) {
          if (route.matched.length != 0) {
            lastMatched = route.matched.slice(-1);
            if (lastMatched) {
              if (lastMatched.length != 0) {
                lastMatchedPath = lastMatched[0].path;
              }
            }
          }
        }
    
        if (routePath != '/dashboard' && routePath != '/') {
          if (accesos.find(acceso => '/' + acceso.route.trim() == lastMatchedPath
              || '/' + acceso.route.trim() + '/' == lastMatchedPath)) {
            return true;
          }
        } else {
          return true;
        }
    
        if(state.userId == 1) {
          console.log(routePath);
        }
    
        return false;
    }
  },
  tieneAccesoModulo: (state) => (modulo) => {
    let accesos = getAccesos();

    switch (state.rolId) {
      case 1:
      case 2:
      case 6:  
      case 8:
        return true;    
    
      default:
        if(accesos.find((acceso) => { return acceso.modulo.trim() == modulo })) {
          return true;
        }
        return false;
    }
  },

  presupuestoInternoRenglonDatos(state) {
    return state.presupuestoInternoRenglonDatos;
  },
  presupuestoInternoRenglonVista(state) {
    return state.presupuestoInternoRenglonVista;
  },
};

function getMenu(state) {
  state.nav = [];

  state.nav.push({
      name: 'Tablero de Control',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: ''
      }
    });

  /* Ventas */
  if (tieneAccesoRuta(state, 'ventas')) {

    let parentItem = addNavItem(null, 'Ventas', 'ventas', 'icon-star');

    addNavItemValidated(parentItem, 'Presupuestos Internos', 'ventas/presupuestosinternos', 'icon-star');
    addNavItemValidated(parentItem, 'Presupuestos Cancelados', 'ventas/presupuestos-cancelados', 'icon-star');
    addNavItemValidated(parentItem, 'Buscador de Ordenes a Proveedores', 'ventas/subtrabajos', 'icon-star');
    // addNavItemValidated(parentItem, 'Subtrabajos', 'ventas/subtrabajos', 'icon-star');
    addNavItemValidated(parentItem, 'Facturas Proforma', 'ventas/facturas-proforma', 'icon-star');
    addNavItemValidated(parentItem, 'Certificados de Servicio', 'ventas/certificados-servicio', 'icon-star');
    addNavItemValidated(parentItem, 'Facturas', 'ventas/facturas', 'icon-star');
    addNavItemValidated(parentItem, 'Facturas Negociadas', 'ventas/facturas-negociadas', 'icon-star');
  }
  
  /* Diseño */
  if (tieneAccesoRuta(state, 'disenio')) {
    
    let parentItem = addNavItem(null, 'Diseño', 'disenio', 'icon-picture');
    
    addNavItemValidated(parentItem, 'Dashboard', 'disenio/dashboard', 'icon-event');
    addNavItemValidated(parentItem, 'Tareas', 'disenio/tareas', 'icon-list');
    addNavItemValidated(parentItem, 'Briefs', 'disenio/briefs', 'icon-list');
    // addNavItemValidated(parentItem, 'Briefs', 'disenio/briefs', 'icon-layers');
    // addNavItemValidated(parentItem, 'Briefs de Diseño', 'ventas/briefs', 'icon-star');
  }

  /* Compras */
  if (tieneAccesoRuta(state, 'compras')) {

    let parentItem = addNavItem(null, 'Compras', 'compras', 'icon-star');

    addNavItemValidated(parentItem, 'Compras', 'compras/compras', 'icon-star');
  }
  
  /* Logistica */
  if (tieneAccesoRuta(state, 'logistica')) {

    let parentItem = addNavItem(null, 'Logistica', 'logistica', 'icon-star');

    addNavItemValidated(parentItem, 'Remitos', 'logistica/remitos', 'icon-star');
    // addNavItemValidated(parentItem, 'Remitos Internos', 'logistica/remitos-internos', 'icon-star');
    addNavItemValidated(parentItem, 'Destinos de Envío', 'logistica/destinos', 'icon-star');
    addNavItemValidated(parentItem, 'Actualización de Importes', 'logistica/actualizacion-importes', 'icon-star');
  }

  /* Stock */
  if (tieneAccesoRuta(state, 'stock')) {

    let parentItem = addNavItem(null, 'Stock', 'stock', 'icon-star');

    // addNavItemValidated(parentItem, 'Ordenes de Trabajo Internas', 'stock/ordenestrabajosinternas', 'icon-star');
    addNavItemValidated(parentItem, 'Stock', 'stock/articulos', 'icon-star');
    addNavItemValidated(parentItem, 'Controles de Stock', 'stock/controles-stock', 'icon-star');
  }

  /* Clientes */
  if (tieneAccesoRuta(state, 'clientes')) {

    let parentItem = addNavItem(null, 'Clientes', 'clientes', 'cui-people');

    addNavItemValidated(parentItem, 'Clientes', 'clientes/clientes', 'cui-people');
    addNavItemValidated(parentItem, 'Instrucciones de Cobro', 'clientes/instrucciones-cobros', 'icon-star');
    addNavItemValidated(parentItem, 'Ordenes de Cobro', 'clientes/cobros', 'icon-star');
    addNavItemValidated(parentItem, 'Cuenta Corriente', 'clientes/cuentacorriente', 'icon-star');
    addNavItemValidated(parentItem, 'Rebate', 'clientes/rebate', 'icon-star');
    addNavItemValidated(parentItem, 'Retenciones de Clientes', 'clientes/retenciones-clientes', 'icon-star');
  }

  /* Proveedores */
  if (tieneAccesoRuta(state, 'proveedores')) {

    let parentItem = addNavItem(null, 'Proveedores', 'proveedores', 'cui-people');

    addNavItemValidated(parentItem, 'Proveedores', 'proveedores/proveedores', 'cui-people');
    addNavItemValidated(parentItem, 'Ordenes a Proveedores', 'proveedores/ordenesproveedores', 'icon-star');
    addNavItemValidated(parentItem, 'Ordenes de Pago', 'proveedores/pagos', 'icon-star');
    addNavItemValidated(parentItem, 'Cuenta Corriente', 'proveedores/cuentacorriente', 'icon-star');
    addNavItemValidated(parentItem, 'Evaluaciones a Proveedores', 'proveedores/evaluaciones-proveedores', 'icon-star');
  }

  /* RRHH */
  if (tieneAccesoRuta(state, 'rrhh')) {

    let parentItem = addNavItem(null, 'RRHH', 'rrhh', 'cui-people');

    addNavItemValidated(parentItem, 'Personal', 'rrhh/personal', 'cui-people');
    addNavItemValidated(parentItem, 'Ingresos/Egresos', 'rrhh/ingresos-egresos', 'icon-star');
    addNavItemValidated(parentItem, 'Liquidaciones de Sueldos', 'rrhh/liquidaciones-sueldos', 'icon-star');
    addNavItemValidated(parentItem, 'Novedades', 'rrhh/novedades', 'icon-star');
    addNavItemValidated(parentItem, 'Calendario', 'rrhh/novedades-calendario', 'icon-calendar');
    addNavItemValidated(parentItem, 'Viaticos', 'rrhh/viaticos', 'icon-star');
    addNavItemValidated(parentItem, 'Encuestas', 'rrhh/encuestas', 'icon-star');
  }

  /* Impuestos */
  if (tieneAccesoRuta(state, 'impuestos')) {

    let parentItem = addNavItem(null, 'Impuestos', 'impuestos', 'icon-star');

    addNavItemValidated(parentItem, 'Organismos', 'impuestos/organismos', 'icon-star');
    addNavItemValidated(parentItem, 'DD.JJ.', 'impuestos/declaraciones-juradas', 'icon-star');
    addNavItemValidated(parentItem, 'Pagos de Impuestos', 'impuestos/pagos', 'icon-star');
    addNavItemValidated(parentItem, 'Estado de Impuestos', 'impuestos/estado', 'icon-star');
    addNavItemValidated(parentItem, 'Planes de Pago', 'impuestos/planes-pagos', 'icon-star');
  }

  /* Tablas */
  if (tieneAccesoRuta(state, 'tablas')) {

    let parentItem = addNavItem(null, 'Tablas', 'tablas', 'icon-star');

    addNavItemValidated(parentItem, 'Articulos', 'tablas/articulos', 'icon-star');
    addNavItemValidated(parentItem, 'Bancos', 'tablas/bancos', 'icon-star');
    addNavItemValidated(parentItem, 'Canales', 'tablas/canales', 'icon-star');
    addNavItemValidated(parentItem, 'Cargos', 'tablas/cargos', 'icon-star');
    addNavItemValidated(parentItem, 'Conceptos de Gastos', 'tablas/presupuestos-gastos-conceptos', 'icon-star');
    // addNavItemValidated(parentItem, 'Etiquetas de Proveedores', 'tablas/etiquetas-proveedores', 'icon-star');
    addNavItemValidated(parentItem, 'Formas de Pago', 'tablas/formaspago', 'icon-star');
    addNavItemValidated(parentItem, 'Giros de Empresas', 'tablas/giros-empresas', 'icon-star');
    addNavItemValidated(parentItem, 'Marcas', 'tablas/marcas', 'icon-star');
    addNavItemValidated(parentItem, 'Motivos de Cancelación', 'tablas/cancelacionesmotivos', 'icon-star');
    addNavItemValidated(parentItem, 'Paises', 'tablas/paises', 'icon-star');
    addNavItemValidated(parentItem, 'Provincias', 'tablas/provincias', 'icon-star');
    addNavItemValidated(parentItem, 'Localidades', 'tablas/localidades', 'icon-star');
    addNavItemValidated(parentItem, 'Plan de Cuentas', 'tablas/plan-cuentas', 'icon-star');
    addNavItemValidated(parentItem, 'Rubros de Bienes', 'tablas/rubros-bienes', 'icon-star');
    addNavItemValidated(parentItem, 'Rubros de Intereses Bancarios', 'tablas/rubros-intereses-bancarios', 'icon-star');
    addNavItemValidated(parentItem, 'Rubros de Trabajos', 'tablas/rubrostrabajos', 'icon-star');
    addNavItemValidated(parentItem, 'Tarjetas - Marcas', 'tablas/tarjetasmarcas', 'icon-star');
    addNavItemValidated(parentItem, 'Tareas - Estados', 'tablas/tareas-estados', 'icon-star');
    addNavItemValidated(parentItem, 'Tipos de Articulo', 'tablas/articulostipos', 'icon-star');
    addNavItemValidated(parentItem, 'Tipos de Diseño', 'tablas/tipos-disenios', 'icon-star');
    addNavItemValidated(parentItem, 'Tipos de Movimientos Bancarios', 'tablas/bancosmovimientostipos', 'icon-star');
    addNavItemValidated(parentItem, 'Tipos de Novedades', 'tablas/tipos-novedades', 'icon-star');
    addNavItemValidated(parentItem, 'Tipos de Presupuesto', 'tablas/tipos-presupuestos', 'icon-star');
    addNavItemValidated(parentItem, 'Tipos de Retención', 'tablas/retencionestipos', 'icon-star');
    addNavItemValidated(parentItem, 'Regimenes de Retención', 'tablas/retencionesregimenes', 'icon-star');
    addNavItemValidated(parentItem, 'Rubros de Rendiciones de Viáticos', 'tablas/viaticos-rubros', 'icon-star');
    addNavItemValidated(parentItem, 'Vendedores', 'tablas/vendedores', 'icon-star');
  }

  /* Administracion */
  if (tieneAccesoRuta(state, 'administracion')) {

    let parentItem = addNavItem(null, 'Administración', 'administracion', 'icon-star');

    let cajasItem = addNavItemValidated(parentItem, 'Cajas', 'administracion/cajas', 'icon-star');
    if (cajasItem) {
      addNavItemValidated(cajasItem, 'Cajas', 'administracion/cajas/cajas', 'icon-star');
      addNavItemValidated(cajasItem, 'Cajas - Registros', 'administracion/cajas/cajasregistros', 'icon-star');
    }

    let bancosItem = addNavItemValidated(parentItem, 'Bancos', 'administracion/bancos', 'icon-star');
    if (bancosItem) {
      addNavItemValidated(bancosItem, 'Cuentas Bancarias', 'administracion/bancos/bancoscuentas', 'icon-star');
      addNavItemValidated(bancosItem, 'Libro Banco', 'administracion/bancos/bancosmovimientos', 'icon-star');
      addNavItemValidated(bancosItem, 'Chequeras', 'administracion/bancos/bancoschequeras', 'icon-star');
      addNavItemValidated(bancosItem, 'Cheques Emitidos', 'administracion/bancos/cheques-propios', 'icon-star');
      addNavItemValidated(bancosItem, 'Cheques de Terceros', 'administracion/bancos/cheques-terceros', 'icon-star');
      addNavItemValidated(bancosItem, 'Transferencias Premios', 'administracion/bancos/transferencias-premios', 'icon-star');
    }
    
    let tarjetasItem = addNavItemValidated(parentItem, 'Tarjetas', 'administracion/tarjetas', 'icon-star');
    if (tarjetasItem) {
      addNavItemValidated(tarjetasItem, 'Tarjetas', 'administracion/tarjetas/tarjetas', 'icon-star');
      addNavItemValidated(tarjetasItem, 'Resumenes', 'administracion/tarjetas/tarjetas-resumenes', 'icon-star');
      addNavItemValidated(tarjetasItem, 'Cartera de Cupones', 'administracion/tarjetas/tarjetas-no-resumen', 'icon-star');
    }

    let flujoFondosItem = addNavItemValidated(parentItem, 'Flujo de Fondos', 'administracion/flujo-fondos', 'icon-star');
    if (flujoFondosItem) {
      addNavItemValidated(flujoFondosItem, 'Flujo de Fondos', 'administracion/flujo-fondos/flujo', 'icon-star');
      addNavItemValidated(flujoFondosItem, 'Presupuestos', 'administracion/flujo-fondos/presupuestos', 'icon-star');
    }

    let vendedoresItem = addNavItemValidated(parentItem, 'Vendedores', 'administracion/vendedores', 'icon-star');
    if (vendedoresItem) {
      addNavItemValidated(vendedoresItem, 'Cuenta Corriente', 'administracion/vendedores/cuenta-corriente', 'icon-list');
      addNavItemValidated(vendedoresItem, 'Cuenta Corriente por Cobros', 'administracion/vendedores/cuenta-corriente-cobros', 'icon-list');
    }

    addNavItemValidated(parentItem, 'Bienes', 'administracion/bienes', 'icon-star');

    addNavItemValidated(parentItem, 'Presupuestos de Gastos', 'administracion/presupuestos-gastos', 'icon-star');

    let parametrosItem = addNavItemValidated(parentItem, 'Parámetros', 'administracion/parametros', 'icon-star');
    if (parametrosItem) {
      addNavItemValidated(parametrosItem, 'Generales', 'administracion/parametros/gral', 'icon-star');
      addNavItemValidated(parametrosItem, 'Empresa', 'administracion/parametros/empresa', 'icon-star');
      addNavItemValidated(parametrosItem, 'Factura Electrónica', 'administracion/parametros/fe', 'icon-star');
      addNavItemValidated(parametrosItem, 'Inflación', 'administracion/parametros/inflacion', 'icon-star');
    }

    let indicadoresItem = addNavItemValidated(parentItem, 'Indicadores', 'administracion/indicadores', 'icon-star');
    if (indicadoresItem) {
      // addNavItemValidated(indicadoresItem, 'Gastos', 'administracion/indicadores/gastos', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Gastos/Ventas', 'administracion/indicadores/gastos-ventas', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Compras/Ventas', 'administracion/indicadores/compras-ventas', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Diferencia de Plazos', 'administracion/indicadores/plazo', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Plazo de Cobro', 'administracion/indicadores/plazo-clientes', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Plazo de Pago - Anual', 'administracion/indicadores/plazo-proveedores-anual', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Plazo de Pago - Semestral', 'administracion/indicadores/plazo-proveedores-semestral', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Rentabilidad Bruta - Anual', 'administracion/indicadores/rentabilidad-anual', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Rentabilidad Bruta - Semestral', 'administracion/indicadores/rentabilidad-semestral', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Rentabilidad Neta - Anual', 'administracion/indicadores/rentabilidad-neta-anual', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Rentabilidad Neta - Semestral', 'administracion/indicadores/rentabilidad-neta-semestral', 'icon-star');
      addNavItemValidated(indicadoresItem, 'CO4', 'administracion/indicadores/co4', 'icon-star');
      // addNavItemValidated(indicadoresItem, 'RSE', 'administracion/indicadores/rse', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Ventas', 'administracion/indicadores/ventas', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Ventas - Mix de Clientes - Anual', 'administracion/indicadores/ventas-mix-anual', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Ventas - Mix de Clientes - Semestral', 'administracion/indicadores/ventas-mix-semestral', 'icon-star');
      addNavItemValidated(indicadoresItem, 'Ventas Trimestrales', 'administracion/indicadores/ventas-trimestral', 'icon-star');
    }
  }

  /* Reportes */
  if (tieneAccesoRuta(state, 'reportes')) {

    let parentItem = addNavItem(null, 'Reportes', 'reportes', 'icon-star');

    let rptVentasItem = addNavItemValidated(parentItem, 'Ventas', 'reportes/ventas', 'icon-star');
    if (rptVentasItem) {
      addNavItemValidated(rptVentasItem, 'Resumen de Presupuestos', 'reportes/ventas/presupuestosinternos', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Aperturas/Cierres de Presupuestos', 'reportes/ventas/presupuestos-internos-aperturas-cierres', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Premios x Presupuesto', 'reportes/ventas/presupuestos-internos-premios', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Presupuestos Cancelados', 'reportes/ventas/presupuestos-internos-cancelados', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Presupuestos Cerrados con Saldo', 'reportes/ventas/presupuestos-internos-cerrados', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Ventas', 'reportes/ventas/ventas', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen Comparativo de Ventas', 'reportes/ventas/ventas-comparativo', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Ventas x Cliente', 'reportes/ventas/ventas-resumen-clientes', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Comisiones', 'reportes/ventas/vendedores-comisiones', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Comisiones por Vendedor', 'reportes/ventas/vendedores-comisiones-resumen', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Comisiones Internas', 'reportes/ventas/comisiones-internas', 'icon-star');
      addNavItemValidated(rptVentasItem, 'Resumen de Comisiones por Ventas Cobradas', 'reportes/ventas/vendedores-comisiones-cobros-resumen', 'icon-star');
    }

    let rptComprasItem = addNavItemValidated(parentItem, 'Compras', 'reportes/compras', 'icon-star');
    if (rptComprasItem) {
      // addNavItemValidated(rptComprasItem, 'Resumen de Compras', 'reportes/compras/compras', 'icon-star');
      addNavItemValidated(rptComprasItem, 'Resumen de Compras-Gastos', 'reportes/compras/compras-gastos', 'icon-star');
      addNavItemValidated(rptComprasItem, 'Resumen de Percepciones de Compras', 'reportes/compras/percepciones', 'icon-star');
      addNavItemValidated(rptComprasItem, 'Control de Compras', 'reportes/compras/compras-fecha', 'icon-star');
      addNavItemValidated(rptComprasItem, 'Resumen de Gastos', 'reportes/compras/resumen-gastos', 'icon-star');
      addNavItemValidated(rptComprasItem, 'Resumen de Ordenes-Remitos', 'reportes/compras/ordenes-remitos', 'icon-star');
    }

    let rptClientesItem = addNavItemValidated(parentItem, 'Clientes', 'reportes/clientes', 'icon-star');
    if (rptClientesItem) {
      addNavItemValidated(rptClientesItem, 'Listado de Contactos', 'reportes/clientes/contactos', 'icon-list');
      addNavItemValidated(rptClientesItem, 'Resumen de Deuda', 'reportes/clientes/deuda', 'icon-star');
      addNavItemValidated(rptClientesItem, 'Resumen de Órdenes de Cobro', 'reportes/clientes/cobros', 'icon-star');
      addNavItemValidated(rptClientesItem, 'Resumen de Plazos', 'reportes/clientes/plazos', 'icon-star');
      addNavItemValidated(rptClientesItem, 'Resumen de Retenciones', 'reportes/clientes/retenciones', 'icon-star');
    }

    let rptProveedoresItem = addNavItemValidated(parentItem, 'Proveedores', 'reportes/proveedores', 'icon-star');
    if (rptProveedoresItem) {
      addNavItemValidated(rptProveedoresItem, 'Resumen de Deuda', 'reportes/proveedores/deuda', 'icon-star');
      addNavItemValidated(rptProveedoresItem, 'Resumen de Órdenes Pendientes', 'reportes/proveedores/ordenes-pendientes', 'icon-star');
      addNavItemValidated(rptProveedoresItem, 'Resumen de Órdenes de Pago', 'reportes/proveedores/pagos', 'icon-star');
      addNavItemValidated(rptProveedoresItem, 'Resumen de Plazos', 'reportes/proveedores/plazos', 'icon-star');
      addNavItemValidated(rptProveedoresItem, 'Resumen de Órdenes Negativas', 'reportes/proveedores/ordenes-rentabilidad-negativa', 'icon-star');
    }

    let rptRRHHItem = addNavItemValidated(parentItem, 'RRHH', 'reportes/rrhh', 'icon-star');
    if (rptRRHHItem) {
      addNavItemValidated(rptRRHHItem, 'Encuestas de Usuarios', 'reportes/rrhh/encuestas-usuarios', 'icon-star');
      addNavItemValidated(rptRRHHItem, 'Evolución de Sueldos', 'reportes/rrhh/evolucion-sueldos', 'icon-star');
    }

    let rptAdministracionItem = addNavItemValidated(parentItem, 'Administracion', 'reportes/administracion', 'icon-star');
    if (rptAdministracionItem) {
      // addNavItemValidated(rptAdministracionItem, 'Flujo de Fondos', 'reportes/administracion/flow', 'icon-star');
      addNavItemValidated(rptAdministracionItem, 'Holistor - Ventas', 'reportes/administracion/holistor-ventas', 'icon-star');
    }

    let rptBancosItem = addNavItemValidated(parentItem, 'Bancos', 'reportes/bancos', 'icon-star');
    if (rptBancosItem) {
      addNavItemValidated(rptBancosItem, 'Ingresos vs Gastos', 'reportes/bancos/ingresos-gastos', 'icon-star');
    }

    let rptLogisticaItem = addNavItemValidated(parentItem, 'Logistica', 'reportes/logistica', 'icon-star');
    if (rptLogisticaItem) {
      addNavItemValidated(rptLogisticaItem, 'Resumen de Remitos', 'reportes/logistica/resumen-remitos', 'icon-star');
    }
  }

  /* Seguridad */
  if (tieneAccesoRuta(state, 'seguridad')) {

    let parentItem = addNavItem(null, 'Seguridad', 'seguridad', 'icon-star');

    addNavItemValidated(parentItem, 'Usuarios', 'seguridad/usuarios', 'cui-people');
  }
}

function tieneAccesoRuta(state, ruta) {
  // if (state.userRolId == 1 || state.userRolId == 2) {
  //   return true;
  // } 

  switch (state.rolId) {
    case 1:
    case 2:
    case 6:  
    case 8:
      return true;    
  }
  
  let accesos = getAccesos();

  let accesoHabilitado = accesos.find((acceso) => {
    return acceso.route.trim() == ruta
      || '/' + acceso.route.trim() == ruta
      || '/' + acceso.route.trim() + '/' == ruta;
  });

  if (accesoHabilitado) { 
    return true;
  }

  if (state.userId == 1) {
    console.log(ruta, accesos);
  }

  return false;
}


function addNavItem(parent, navItem, navUrl, navIcon) {
  let item = {
    name: navItem,
    url: '/' + navUrl.trim(),
    icon: navIcon
  }

  let addItem = true;
  if (parent) {
    if (!parent.children) {
      parent.children = [];  
    } 
    parent.children.push(item);
    addItem = false;
  }
  if (addItem) {
    state.nav.push(item);
  }

  return item;
}

function addNavItemValidated(parent, navItem, navUrl, navIcon) {
  let item;

  if (tieneAccesoRuta(state, navUrl)) {
    item = {
      name: navItem,
      url: '/' + navUrl.trim(),
      icon: navIcon
    }

    let addItem = true;
    if (parent) {
      if (!parent.children) {
        parent.children = [];  
      } 
      parent.children.push(item);
      addItem = false;
    }
    if (addItem) {
      state.nav.push(item);
    }
  }

  return item;
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}